/* eslint-disable default-param-last */
import Constants from './Constants.js'
import createSelectors from './createSelectors.js'

const initialState = { 

}
const EMPTY = Object.freeze( [] )

const hooks = []

function ensureGroup( state, group, cloneItems ) {
  const nState = { ...state }
  if ( nState[group] == null ) {
    nState[group] = { 
      config : { idKey : 'id' }, 
      items : cloneItems ? [] : EMPTY,
      lookup : { }
    }
  } else {
    nState[group] = { ...nState[group] }
    if ( cloneItems ) {
      nState[group].items = [ ...nState[group].items ]
      nState[group].lookup = { ...nState[group].lookup }
    }
  }
  return nState
}

function selection( state = initialState, action ) {

  switch ( action.type ) {
    case Constants.SELECTION_CONFIG: {
      const { group, config } = action
      const nState = ensureGroup( state, group ) 
      nState[group].config = { idKey : 'id', ...config }
      return nState
    }

    case Constants.SELECTION_ADD: {
      const { group, items } = action
      const nState = ensureGroup( state, group, true ) 
      const { items : arr, lookup, config } = nState[group]
      const idKey = config.idKey
      let change = false

      if ( Array.isArray( items ) ) {
        for ( let n = 0; n < items.length; n++ ) {
          change |= addItem( items[n], arr, lookup, idKey )
        }
      } else {
        change = addItem( items, arr, lookup, idKey )
      }
      return change ? nState : state
    }

    case Constants.SELECTION_SET: {
      const { group, items } = action
      const nState = ensureGroup( state, group ) 
      const config = nState[group].config
      const idKey = config.idKey

      nState[group].items = items == null ? EMPTY : 
        Array.isArray( items ) ? [ ...items ] : [ items ]
      nState[group].lookup = computeLookup( nState[group].items, idKey )
      return nState
    }

    case Constants.SELECTION_REMOVE: {

      const { group, items } = action
      const nState = ensureGroup( state, group, true ) 
      const { items : arr, lookup, config } = nState[group]
      const idKey = config.idKey
      let change = false

      if ( Array.isArray( items ) ) {
        for ( let n = 0; n < items.length; n++ ) {
          change |= removeItem( items[n], arr, lookup, idKey, true )
        }
      } else {
        change = removeItem( items, arr, lookup, idKey, true )
      }
      if ( !change ) {
        return state
      }
      if ( nState[group].items.length === 0 ) {
        nState[group].items = EMPTY
      }
      // nState[group].lookup = computeLookup( nState[group].items, idKey )
      return nState
    }

    case Constants.SELECTION_CLEAR: {
      const { group } = action
      const nState = ensureGroup( state, group ) 
      if ( nState[group].length === 0 ) {
        // already clear
        return state
      }
      nState[group].items = EMPTY
      nState[group].lookup = { }
      return nState
    }

    case Constants.SELECTION_POP: {
      const { group } = action
      const nState = ensureGroup( state, group, true ) 
      const { items : arr, lookup, config } = nState[group]

      if ( arr.length === 0 ) {
        return state
      }

      const idKey = config.idKey
      let change = false

      change = removeItem( arr.at( -1 ), arr, lookup, idKey, true )

      if ( !change ) {
        return state
      }

      if ( nState[group].items.length === 0 ) {
        nState[group].items = EMPTY
      }

      return nState
    }

    case Constants.SELECTION_CLEAR_ALL: {
      return { }
    }
    default: 
      return runHooks( state, action )
  }
}

function computeLookup( arr, idKey ) {
  const lookup = { }
  arr.forEach( ( item, idx ) => {
    lookup[item[idKey]] = idx
  } )
  return lookup
}

function addItem( item, arr, lookup, idKey ) {
  const id = item[idKey]
  const idx = lookup[id]
  if ( idx !== undefined ) {
    if ( shallowEqual( arr[idx], item ) ) {
      return false// no change
    }
    // eslint-disable-next-line no-param-reassign
    arr[idx] = item
  } else {
    // eslint-disable-next-line no-param-reassign
    lookup[id] = arr.length
    arr.push( item )
  }
  return true
}

function removeItem( item, arr, lookup, idKey, adjustLookup ) {
  const id = typeof item === 'object' ? item[idKey] : item
  const idx = lookup[id]
  if ( idx === undefined ) {
    return false
  }
  // eslint-disable-next-line no-param-reassign
  delete lookup[id]
  arr.splice( idx, 1 )
  if ( adjustLookup ) {
    for ( let n = idx; n < arr.length; n++ ) {
      const aItem = arr[n]
      const aId = aItem[idKey] 
      lookup[aId] = n
    }
  }
  return true
}

function shallowEqual( a, b ) {
  const ak = Object.keys( a )
  const bk = Object.keys( b )
  if ( ak.length !== bk.length ) {
    return false
  }
  let checkB = false // to foil objects like { key : undefined }
  for ( let n = 0; n < ak.length; n++ ) {
    if ( a[ak[n]] !== b[ak[n]] ) {
      return false
    } 
    if ( a[ak[n]] === undefined ) {
      checkB = true
    }
  }
  if ( checkB ) {
    for ( let n = 0; n < bk.length; n++ ) {
      if ( a[bk[n]] !== b[bk[n]] ) {
        return false
      } 
    }
  }
  return true
}

function get( state, group ) {
  return ( state && state[group] )
}
/**
 * This operates against the result of get( state, group ) and 
 * returns true if the given id is in the list
 */
function isSelected( groupData, id ) {
  return ( groupData && groupData.lookup[id] !== undefined ) || false
}

function getSelected( groupData ) {
  return ( groupData && groupData.items ) || EMPTY
}

/**
 * This operates against the result of get( state, group ) and 
 * returns the number items selected
 */
function count( groupData ) {
  return ( groupData && groupData.items.length ) || 0
}

/**
 * This operates against the result of get( state, group ) and 
 * returns true if the count is zero
 */
function isEmpty( groupData ) {
  return count( groupData ) === 0
}

/**
 * This operates against the result of get( state, group ) and 
 * returns an array of ids in the group
 */
function getIds( groupData ) {
  if ( groupData == null ) {
    return EMPTY
  }
  return Object.keys( groupData.lookup )
}

selection.createSelectors = ( key, createSetStateKey = false ) => {
  return { ...createSelectors( key, { get }, createSetStateKey ), getIds, getSelected, isSelected, count, isEmpty }
}

// Set up initial defaults to make methods available immediately with default state key
const selectors = selection.createSelectors( 'selection', true )
Object.keys( selectors ).forEach( ( key ) => { selection[key] = selectors[key] } )

/**
 * Adds a selection hook. The function will recieve (state, action) and should
 * return the state to use for Selections. It must at least return the given state.
 * If it makes a mod, it should create a new object with the modification and return
 * that. This will only be invoked for non-Selection actions. This is mostly to allow
 * object to be removed from the Selection mechanism when they themselves are removed.
 */
function addHook( fn ) {
  if ( !hooks.includes( fn ) ) {
    hooks.push( fn )
  }
}

function removeHook( fn ) {
  const idx = hooks.indexOf( fn )
  if ( idx >= 0 ) {
    hooks.splice( idx, 1 )
  }
}

function runHooks( state, action ) {
  if ( hooks.length === 0 ) {
    return state
  }
  let nState = state
  for ( let n = 0; n < hooks.length; n++ ) {
    nState = hooks[n]( nState, action )
  }
  return nState
}

/**
 * Given the selection state, this will remove the given id/ids from 
 * all groups in the state.
 */
function hookRemoveFromAll( state, ids ) {
  if ( ids == null ) {
    return state
  }
  const nState = { ...state }
  const keys = Object.keys( nState )
  let change = false
  const arr = Array.isArray( ids ) ? ids : [ ids ]
  for ( let idx = 0; idx < arr.length; idx++ ) {
    const id = arr[idx]
    for ( let n = 0; n < keys.length; n++ ) {
      const key = keys[n]
      const grp = nState[key]
      if ( isSelected( grp, id ) ) {
        change = true
        nState[key] = { 
          ...grp,
          items : [ ...grp.items ],
          lookup : { ...nState[key].lookup }
        }
        removeItem( id, nState[key].items, nState[key].lookup, nState[key].config.idKey, true )
      }
    }
  }

  return change ? nState : state
}

selection.addHook = addHook
selection.removeHook = removeHook
selection.hookRemoveFromAll = hookRemoveFromAll

export default selection
